export default __webpack_public_path__ + "static/media/Sonia Salwan.157a0c93.jpg";